<template>
  <div class="group/wheel fixed bottom-12 right-12 z-90 flex flex-col">
    <Transition
      enter-active-class="duration-300 ease-out"
      enter-from-class="transform opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="duration-300 ease-in"
      leave-from-class="opacity-100"
      leave-to-class="transform opacity-0"
    >
      <div
        v-if="show"
        class="mb-2 flex h-fit w-fit flex-col gap-1 rounded-lg border border-slate-300 bg-white p-3 shadow-2xl"
      >
        <div
          v-for="color in colorAsArray"
          :key="color.title"
          class="flex flex-row items-center gap-2"
        >
          <span
            :data-tint="color.color"
            class="h-4 w-4 rounded-md bg-primary"
          ></span>
          <span>{{ color.title }}</span>
        </div>
      </div>
    </Transition>
    <div class="flex flex-row justify-end">
      <button class="wheel-color h-10 w-10 rounded-lg" @click="show = !show">
        &nbsp;
      </button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { EventType } from '@/assets/enums'

export default {
  name: 'WheelEventColor',
  emits: ['update:color'],
  data() {
    return {
      show: false
    }
  },
  computed: {
    ...mapGetters({
      listColor: 'metadata/getListColors',
      metadata: 'metadata/getInitialMetadata'
    }),
    colorAsArray() {
      return Object.entries(EventType).reduce((array, event_type) => {
        if (this.metadata.settings[`${event_type[0].toLowerCase()}_enabled`]) {
          array.push({
            title: this.$t(`enums.event.type.${event_type[1]}`),
            color:
              this.metadata.settings[`${event_type[0].toLowerCase()}_color`]
          })
        }
        return array
      }, [])
    }
  },
  mounted() {
  }
}
</script>

<style>
.wheel-color {
  background: conic-gradient(
    from 90deg,
    #fe2712,
    #fc600a,
    #fb9902,
    #fccc1a,
    #fefe33,
    #b2d732,
    #66b032,
    #347c98,
    #0247fe,
    #4424d6,
    #8601af,
    #c21460,
    #fe2712
  );
}
</style>
